import { useCallback, useEffect, useState } from 'react';
import { TextField } from '@adobe/react-spectrum';
import { useDebounce } from '@uidotdev/usehooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { useTranslation } from 'react-i18next';

interface IFilterSearchTextBoxProps {
  onSearchChange: (params: {}) => void;
  filterParams: any;
  serachedText?: string;
}

const FilterSearchTextBox: React.FC<IFilterSearchTextBoxProps> = ({ onSearchChange, filterParams, serachedText }) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const [filterTerm, setFilterTerm] = useState<string>(serachedText ?? '');
  const debouncedFilterTerm = useDebounce(filterTerm, 1000);
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_filters.${key}`, { ns: 'invoice' });

  useEffect(() => {
    (async () => {
      searchServiceActivities();
    })();
  }, [debouncedFilterTerm]);

  useEffect(() => {
    setFilterTerm('');
  }, [selectedApp]);

  const handleFiltering = async (e: any) => {
    setFilterTerm(e);
  };

  const searchServiceActivities = useCallback(async () => {

    if (!filterParams.FILTER.COL.some((obj: any) => obj.name === 'invoiceNumber') && debouncedFilterTerm === '') {
      return;
    }

    const updatedArray = filterParams.FILTER.COL.map((obj: any) => (obj.name === 'invoiceNumber' ? { ...obj, value: debouncedFilterTerm } : obj));

    const hasNameSearch = filterParams.FILTER.COL.some((obj: any) => obj.name === 'invoiceNumber');

    if (!hasNameSearch && debouncedFilterTerm) {
      updatedArray.push({
        name: 'invoiceNumber',
        value: debouncedFilterTerm,
      });
    }

    filterParams.FILTER.COL = updatedArray;
    filterParams.FILTER.COL = filterParams.FILTER.COL.filter((col: any) => col.value !== '');
    onSearchChange(filterParams);
  }, [debouncedFilterTerm]);

  return (
    <TextField
      value={filterTerm}
      width={'100%'}
      onChange={handleFiltering}
      aria-label={_t('search')}
      placeholder={_t('search')}
    />
  );
};

export default FilterSearchTextBox;
